export default __webpack_public_path__ + "static/media/power-screenshot.c3b38d24.png";